import {
  REACT_APP_APPLICATION_MODE,
  REACT_APP_MIDDLEWARE_COMMAND_URL, REACT_APP_MIDDLEWARE_ENERGY_URL,
  REACT_APP_MIDDLEWARE_GATEWAY_URL,
  REACT_APP_MIDDLEWARE_INDOOR_URL,
  REACT_APP_MIDDLEWARE_OUTDOOR_URL, REACT_APP_MIDDLEWARE_URL
} from "../utils/config/configs";

export const apiKey = "0a6vqefxba";
export const integrations_apiKey = "h1rdrrtptb";

//Para testar localmente deve ter no env esta variavel de ambiente como 'development'
const applicationMode = REACT_APP_APPLICATION_MODE || 'production';

const query = {
  // baseURL: 'https://'+ apiKey +'.execute-api.eu-west-1.amazonaws.com/v3_0_01',
  baseURL: "http://localhost:3001",
  middlewareURL: applicationMode === 'development' ? REACT_APP_MIDDLEWARE_URL : REACT_APP_MIDDLEWARE_GATEWAY_URL + '/core/api',
  middlewareCommandURL: applicationMode === 'development' ? REACT_APP_MIDDLEWARE_COMMAND_URL : REACT_APP_MIDDLEWARE_GATEWAY_URL + '/command/api',
  middlewareEnergyURL: applicationMode === 'development' ? REACT_APP_MIDDLEWARE_ENERGY_URL : REACT_APP_MIDDLEWARE_GATEWAY_URL + '/energy/api',
  middlewareIndoorURL: applicationMode === 'development' ? REACT_APP_MIDDLEWARE_INDOOR_URL : REACT_APP_MIDDLEWARE_GATEWAY_URL + '/indoor/api',
  middlewareOutdoorURL: applicationMode === 'development' ? REACT_APP_MIDDLEWARE_OUTDOOR_URL : REACT_APP_MIDDLEWARE_GATEWAY_URL + '/outdoor/api',
  middlewareGatewayURL: REACT_APP_MIDDLEWARE_GATEWAY_URL,
  path: {
    //Digital Twin
    providersData: "/providers",
    dependentsData: "/dependents",

    // Buildings microfrontend
    mapItems: "/map/items",

    //Create Incidents
    getIncidentProperties: "/incidents/properties",
    getIncidentCategories: "/incidents/categories",
    createIncident: "/incidents/external",

    // Item
    getSubtenants: "/items/subtenants",
    getDistinctProperties: "/items/distinct-properties",
    getItems: "/items",
    getAllTenants: "/items/all-tenants",
    getClassesByFamiliesServiceCatalog: "/service-catalog/grouped-by-family",
    getItemById: "/items/id",

    // Building metrics
    processedMetricsBuildings: "/processed-metrics/buildings",

    // Users
    projectConfigurations: "/configurations/projects",
    userConfigurations: "/user-configurations",

    // Tenant Configurations
    tenantConfigurations: '/tenant-configurations',

  },
};

export default query;
